import { GetBanksListServiceResponse } from "../../interfaces";

export const GET_BANKS_LIST_SERVICE_MOCK: GetBanksListServiceResponse = {
    bancosPreliquidacion: [
        {
            codigo: 7,
            descripcion: "GALICIA(0070999020000051878944)"
        },
        {
            codigo: 15,
            descripcion: "ICBC(0150931502000004416050)"
        },
        {
            codigo: 11,
            descripcion: "NACION(011059952000002730446444)"
        },
        {
            codigo: 27,
            descripcion: "SUPERVIELLE(0270100010000490110013)"
        }
    ]
}